import ManageHeader from "@components/ManageHeader";
import React, { useState } from "react";
import { Row, Col } from "react-bootstrap";
import Hotel from "@assets/slide/ka.jpg";
import { BedDouble, User, Bed } from "lucide-react";
import AJXLoader from "@components/AJXLoader";
import LoadError from "@components/LoadError";
import { apiSend, getRoute } from "@services/axios";
import { QueryClient, QueryClientProvider, useQuery } from "react-query";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import { Config } from "@config/config";
import { Button } from "rsuite";
import { useModal } from "@components/ModalContext";
import { saveChangeStatusRoom } from "./Actions";
import RoomPricing from "./components/RoomPricing";
import { confirm } from "@global/actions";

const queryClient = new QueryClient();

function RoomTypesAndPriceLevels(props) {
  const { t } = useTranslation();
  const config = new Config(t);

  return (
    <>
      <ManageHeader
        title={t("")}
        content={t("ho_act_typeP")}
        icon={<Bed size={25} strokeWidth={1.5} />}
      />
      <QueryClientProvider client={queryClient}>
        <DataRoom t={t} {...props} config={config} />
      </QueryClientProvider>
    </>
  );
}

export default RoomTypesAndPriceLevels;

function DataRoom(props) {
  const t = props.t;
  const config = props.config;
  const id = useParams().id;
  const paramUseModal = useModal();
  const [rooms, setRooms] = useState([]);
  const load = async () => {
    const response = await apiSend(
      [getRoute("PRODUCT_RETRIEVE"), id, "rooms"].join("/"),
      "get"
    );
    if (response?.data?.request?.status === true) {
      setRooms(response?.data?.result?.rooms);
    }

    return response?.data?.request?.status;
  };
  //mode={props.mode} t={t} closeModal={closeModal}
  const { isLoading, error } = useQuery("repoData", () => load());
  if (isLoading) return <AJXLoader />;
  if (error) return <LoadError message={t("not_found")} />;

  const updateRoom = (item, index) => {
    paramUseModal.setSize("xl");
    paramUseModal.setTitle(item.type + " " + item.option);
    paramUseModal.openModal(
      <RoomPricing productId={id} item={item} index={index} />
    );
  };

  const changeStatus = (item, index) => {
    confirm({
      useModal: paramUseModal,
      title: item.type + " " + item.option,
      params: { item: item, index: index },
      messageConfirm:
        item.status === "enabled"
          ? t("do_you_really_want_to_deactivate_this_room")
          : t("do_you_really_want_to_activate_this_room"),
      handleChange: handleChangeStatus,
    });
  };

  const handleChangeStatus = async (params) => {
    var status = params.item.status === "enabled" ? "disabled" : "enabled";
    const res = await saveChangeStatusRoom(id, params.item.id, status);
    paramUseModal.closeModal();
    if (res === true) {
      params.item.status = status;
      rooms[params.index] = params.item;
    }
  };
console.log('rooms',rooms)
  return (
    <div className="container my-4">
      {rooms.map((room, rowIndex) => (
        <Row key={rowIndex}>
          <Col lg="10" xl="12" className="p-1">
            <div className="my-2 bg-white p-2">
              <div className="bg-white rounded-2 border recommendations-item">
                <Row>
                  <Col xl="3">
                    <div className="h-100 p-1">
                      <img
                        className="rounded"
                        alt="myhotel"
                        src={Hotel}
                        height="100%"
                        width="100%"
                      />
                    </div>
                  </Col>
                  <Col xl="6" className="mt-2 d-flex align-items-center">
                    <div className="w-100 px-3 py-3 pb-3">
                      <div className="w-100 title-blue fw-bold my-2 fs-5">
                        <Button
                          color={props.config.statusColor(room.status)}
                          appearance="primary"
                        ></Button>{" "}
                        {room.type} {room.option}
                      </div>
                      <div className="w-100 d-flex align-items-center my-2 ">
                        <div className="w-100 d-flex flex-column justify-content-around">
                          <div className="mt-1 d-flex flex-row justify-content-between">
                            <span className="">{t("ho_act_RoomNumber")} :</span>
                            <b className=""> {room.id}</b>
                          </div>
                          <div className="mt-1 d-flex flex-row justify-content-between">
                            <span className="">
                              {t("ho_act_segmentType")} :
                            </span>
                            <b className=""> {room.type}</b>
                          </div>
                          <div className="mt-1 d-flex flex-row justify-content-between">
                            <span className="">
                              {t("ho_act_best")} : {room.year}
                            </span>
                            <b className="">
                              {room.min_price} {props.profile.provider.currency}
                            </b>
                          </div>
                        </div>
                      </div>
                      <div className="pt-2">
                        <Button
                          color="blue"
                          appearance="primary"
                          onClick={() => updateRoom(room, rowIndex)}
                        >
                          {t("ho_act_update")}
                        </Button>{" "}
                        <Button
                          color={props.config.statusActionColor(room.status)}
                          appearance="primary"
                          onClick={() => changeStatus(room, rowIndex)}
                        >
                          {props.config.userStatusAction(room.status)}
                        </Button>{" "}
                      </div>
                    </div>
                  </Col>
                  <Col xl="3" className="mt-4 ">
                    <div className="border-start d-flex flex-column align-items-left justify-content-between  p-2 ">
                      <span className="mt-4">
                        {config.smoking(room.is_smoking_allowed)}
                      </span>
                      <span className="mt-1">
                        <BedDouble className="mx-3" strokeWidth={1.5} /> 
                        {room.bed} * {room.number_of_beds}
                      </span>
                      <span className="my-1 ">
                        {" "}
                        <User className="mx-1" strokeWidth={1.5} />
                        {t("ho_act_occu")} : {room.real_number_pax}
                      </span>

                      <span className="mt-1">
                        <User className="mx-3" width={18} />
                        {t("adult")} min = {room.adult.min} max ={" "}
                        {room.adult.max}
                        <p></p>
                        <User className="mx-3" width={18} />
                        {t("child")} min ={room.child.min} max ={room.child.max}
                      </span>
                    </div>
                  </Col>
                </Row>
              </div>
            </div>
          </Col>
        </Row>
      ))}
    </div>
  );
}
